import { IImage } from './i-image';

export interface IProduct {
  id: string;
  name: string;
  description: string;
  barcode: string;
  images: IImage[];
  category: IProductCategory;
  brand: IProductBrand;
  properties: IProductProperty[];
  productMeasurement?: string;
  isActive?: boolean;
  fastestMovingOrLowestSupplier: IProductLocationSupplierPrice;
}

export interface IProductLocationSupplierPrice {
  tradingName: string;
  price: number;
}

export interface IProductCategory {
  id: string;
  name: string;
}

export interface IProductProperty {
  key: string;
  value: string;
  locale?: string;
  showPublic?: boolean;
}

export interface IProductBrand {
  id: string;
  name: string;
  images: IImage[];
}
